<div
  (click)="imageClick(0)"
  class="innerBanner"
  [style.background-image]="
    bannerImage ? 'url(' + bannerImage + ')' : 'url(' + '../../../assets/images/NoImage.jpg' + ')'
  "
>
  <!-- inner banner-->
  <div class="bannerText"></div>
</div>
<!-- <nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><a href="/home">Home</a></li>
    <li class="breadcrumb-item active" aria-current="page">{{ aboutUsInfoData.bannerTitle }}</li>
  </ol>
</nav> -->

<p-galleria
  [(value)]="images"
  [(visible)]="displayCustom"
  [(activeIndex)]="activeIndex"
  [fullScreen]="true"
  [showItemNavigators]="false"
  [baseZIndex]="100000"
  [containerStyle]="{ 'max-width': '90%' }"
>
  <ng-template pTemplate="item" let-item>
    <img [src]="item" class="gallery-image" />
  </ng-template>
  <!-- <ng-template pTemplate="thumbnail" let-item>
    <div class="grid grid-nogutter justify-content-center">
      <img [src]="highLights.bannerImage" style="display: block" />
    </div>
  </ng-template> -->
</p-galleria>
<div class="container contentPanel">
  <!-- <app-breadcrumb></app-breadcrumb> -->
  <app-breadcrumb-row></app-breadcrumb-row>
  <h1>{{ aboutUsInfoData.bannerTitle }}</h1>
  <p [innerHTML]="aboutUsInfoData.content"></p>
  <p>&nbsp;</p>
</div>
